import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const putHIDetails = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/UpdateCarePlanInformation`,
    data,
  );
  return response.data;
};

export { putHIDetails };
